<div class="container mt-4">
  <div class="card shadow-sm">
    <div class="table-responsive p-3">

      <!-- Header & ADD Button -->
      <div class="d-flex justify-content-between align-items-center mb-3">
        <h4 class="mb-0">User Master Details</h4>
        <button class="btn btn-primary" (click)="gotousermaster()">ADD NEW</button>
      </div>

      <!-- Employee Table -->
       <div class="table-responsive modern-table-container">
  <table class="table table-bordered table-hover">
        <thead class="table-dark">
          <tr>
            <th>#</th>
             <th>Action</th>
            <th>ID</th>
            <th>FirstName</th>
            <th>UserName</th>
            <th>Password</th>
            <th>Rights</th>
            
          </tr>
        </thead>
        <tbody ><!--*ngIf="appservice.employeemasterdata && appservice.employeemasterdata.length > 0"-->
          <tr *ngFor="let user of usermasterdatas; let i = index">
            <!-- Index -->
            <td>{{ i + 1 }}</td>

            <!-- Action Dropdown -->
            <td class="text-center"><div class="Dropdown">
              <button class="icon-button me-1"  (click)="editUser(user.Um_iid)" title="Edit">
    <img src="assets/images/edit.png" alt="Edit" width="20" height="20">
  </button>
  <button class="icon-button" (click)="deleteUser(user.Um_iid)" title="Delete">
    <img src="assets/images/bin2.png" alt="Delete" width="20" height="20">
  </button></div>
            </td>

            <!-- Data Columns -->
            <td>{{ user.Um_iid }}</td>
            <td>{{ user.Um_FirstName }}</td>
            <td>{{ user.Um_UserName }}</td>
            <td>{{ user.Um_Password }}</td>
            <td>{{ user.Um_rights }}</td>
            
          </tr>
        </tbody>
      </table>
</div>
    </div>
  </div>
</div>
